import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { TemplateRefDiamondsService } from '../layout/component-layout/profile-character/level-profile/diamonds-popup/template-ref-diamonds.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';
import { filter } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { AppState } from 'src/app/shareModule/states/app.state';

@Component({
  selector: 'app-advanced-settings-referral',
  templateUrl: './advanced-settings-referral.component.html',
  styleUrl: './advanced-settings-referral.component.scss',
})
export class AdvancedSettingsReferralComponent implements OnInit {
  tab: number = 0;
  profileInfo: any = { isVerified: false };
  public modalRef: any = null;
  public selectedOTP: any = '';
  public invalidOtp: string = '';
  public charName: string = '';
  public email: string = '';
  public isEmailVerify: boolean = false;
  public currentEmail: string = '';
  public postalCode: string = '';
  public phoneNumber: string = '';
  public shortDescription: string = '';
  public imgUrl = environment.ImageUrl;
  public certifiedSelect: any = [
    { value: 'Tutor', label: 'Tutor' },
    { value: 'Handyman', label: 'Handyman' },
    { value: 'Butler', label: 'Butler' },
    { value: 'Driver', label: 'Driver' },
    { value: 'Cleaner', label: 'Cleaner' },
    { value: 'Chef', label: 'Chef' },
  ];
  public certifiedValue: any = [];
  public regionList = [];
  public selectedMemberRegion = '';
  public selectedMemberRegionId = '';
  public buyerContact: any = false;
  selectedTheme: string = 'space';
  tutorials: boolean = JSON.parse(localStorage.getItem('tutorials')) || false;
  turnOffWhatsapp: any = false;
  showVerificationTelegram = false;
  referralCode: string = '';

  constructor(
    private toastr: ToastrService,
    private location: Location,
    private auth: AuthServiceService,
    public roleService: RoleService,
    private sharedService: SharedService,
    private customerService: CustomerService,
    public modalService: NgbModal,
    private http: HttpClient,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private myModalService: ModalService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.route.params.subscribe((params) => {
      if (params['referralCode']) {
        this.referralCode = params['referralCode'];
      }
    });
  }

  ngOnInit(): void {
    this.commonService.regionObserver.subscribe((resp: any) => {
      this.regionList = resp.map((i) => {
        return {
          keyName: i.name,
          sub: i.subRegions.map((i: any) => {
            return { ...i, keyName: i.name };
          }),
        };
      });
    });

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe(
        (resp: User) => {
          const data = resp;
          this.charName = data.profileCharacterName;
          this.email = data?.email;
          this.currentEmail = data?.email;
          this.isEmailVerify = data?.isEmailVerify == 0 ? false : true;
          this.postalCode = data.postalCode;
          this.shortDescription = data.shortDescription;
          this.buyerContact = data.buyerContact;
          this.turnOffWhatsapp = data.turnOffWhatsapp;
          this.selectedMemberRegion = data?.regionName || '';
          this.selectedMemberRegionId = data?.region || '';
          this.certifiedValue = JSON.parse(data?.certified ?? '[]');
          this.profileInfo = resp;
          this.selectedTheme = resp?.theme;
        },
        (e) => {
          this.toastr.warning('Please Login First !');
          this.router.navigate([`/${this.referralCode}`]);
        }
      );
  }
  goBack() {
    this.location.back();
  }
  getTelegramLinks() {
    if (this.profileInfo?.isTelegramVerified) {
      return;
    }
    // this.http
    //   .get(environment.baseUrlAdmin + 'getTelegramVerificationLink')
    //   .subscribe((e: any) => {
    //     window.open('https://t.me/kachiing_sg_bot?start=verify' + e.telegramLink, "_blank")
    //   });
    this.auth.get_telegram_verification_link().subscribe((e: any) => {
      window.open(`${e.telegramLink}`, '_blank');
    }); //because bot username changes in demo and prod
  }

  public saveProfileInfo(): void {
    // Validate email using the pattern
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
      this.toastr.error('Please enter a valid email address.');
      return;
    }

    this.auth
      .updateProfileCharacterDetails({
        profileCharacterName: this.charName,
        postalCode: this.postalCode,
        email: this.email,
        shortDescription: this.shortDescription,
        certifiedValue: JSON.stringify(this.certifiedValue),
        region: this.selectedMemberRegionId,
        buyerContact: this.buyerContact,
        turnOffWhatsapp: this.turnOffWhatsapp,
        theme: this.selectedTheme,
      })
      .subscribe(
        (resp: ApiResponse) => {
          if (resp.message) {
            this.store.dispatch(loadUser({}));
            if (
              (this.email && !this.currentEmail) ||
              this.email != this.currentEmail
            ) {
              this.saveMemberEmail(this.email);
            }
            this.toastr.success(resp.message);
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  public saveMemberEmail(email) {
    this.customerService
      .saveMemberEmail({
        email: email,
      })
      .subscribe(
        (resp: ApiResponse) => {
          if (resp.message) {
            this.toastr.success(resp.message);
            this.store.dispatch(loadUser({}));
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  onThemeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const theme = selectElement.value;
    localStorage.setItem('selectedTheme', theme);
    if (this.selectedTheme) {
      document.documentElement.classList.remove(this.selectedTheme);
    }
    document.documentElement.classList.add(theme);
    this.selectedTheme = theme;
  }
  onTutorialsChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    localStorage.setItem('tutorials', JSON.stringify(isChecked));
    this.tutorials = isChecked;
  }

  public otpSent: boolean = false;
  public otp: string = '';
  public passcode: string = '';
  public passcodeConfirm: string = '';
  public isLoading: boolean = false;
  public otpError: string = '';
  public isReset: boolean = false;

  delaySendOTP: number = 0;

  handleSendOTP() {
    if (this.delaySendOTP < 1)
      this.auth
        .member_send_otp({
          phone: this.profileInfo?.phone,
        })
        .subscribe(
          (resp: any) => {
            const result = resp.body;
            if (result.success) {
              this.toastr.success(resp.message);
            } else {
              this.toastr.error(resp.message);
            }
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
            }, 1000);
          },
          (e) => {
            this.toastr.error('Internal Server Error');
          }
        );
  }

  handleVerify() {
    if (this.passcode == '') return this.toastr.error('Please Fill Passcode');
    if (this.passcode != this.passcodeConfirm) {
      return this.toastr.error("Passcode Confirmation Doesn't Match");
    }

    if (this.otp == '') return this.toastr.error('Please Fill OTP');

    this.auth
      .member_reset_passcode({
        password: this.passcode,
        otp: this.otp,
        phone: this.profileInfo?.phone,
      })
      .subscribe(
        (resp: any) => {
          const result = resp.body;
          if (result.success) {
            this.toastr.success(resp.message);
          } else {
            this.toastr.error(resp.message);
          }
        },
        (e) => {
          this.toastr.error('Internal Server Error');
        }
      );
  }

  async onChangeOtp(e: any) {
    this.otp = e.target.value;
  }

  async onChangePasscode(e: any) {
    this.passcode = e.target.value;
  }

  public verifyEmailOtp() {
    if (this.selectedOTP && this.selectedOTP.length == 6) {
      this.customerService
        .verifyEmailOtp({
          otp: this.selectedOTP,
          email: this.email,
        })
        .subscribe(
          (resp: ApiResponse) => {
            if (resp.message) {
              this.store.dispatch(loadUser({}));
              this.toastr.success(resp.message);
              this.modalRef ? this.modalRef.close() : '';
            }
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
    } else {
      this.toastr.error('Invalid OTP!');
    }
  }

  public handleOTPVerification(modal: any) {
    if (!this.email) return this.toastr.error('Please enter your email');
    this.saveProfileInfo();
    this.selectedOTP = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public ignoreTag(tag) {
    this.customerService
      .updateTag({ ignoreTag: tag })
      .subscribe((resp: ApiResponse) => {
        this.toastr.success('Tag remove successfully');
        this.commonService.getTagList();
      });
  }
}
